import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';

/**
 * Application Entry Point
 * Renders the main App component into the DOM
 */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}


const root = createRoot(rootElement);

root.render(<App />);
  